import React, { useEffect, useState, useRef, useCallback } from "react";

import { roles_users_get, roles_users_available_get } from "../../services/configuration/rol";


import "./rol.css";
import { Confirm, useDialog } from "react-st-modal";
import DELETE from "../../imgComponents/borrar.png";
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import ADD from "../../imgComponents/agregarRole.png";
import SAVE from "../../imgComponents/save.png";
import { post_rol_user } from "../../services/configuration/rol";
import MODAL_TABLE from "../../main_components/modal/modal_Table";

const Module = ({ name, submodules, module, setData, module2, setData2, flag_data }) => {
  const [showSubmodules, setShowSubmodules] = useState(false);
  const toggleSubmodules = () => {
    setShowSubmodules(!showSubmodules);
  };

  return (

    <div className="module-container" style={{ display: submodules.length === 0 ? "none" : "" }}>
      <div className="module-header" onClick={toggleSubmodules}>
        <KeyboardDoubleArrowDownIcon style={{ display: showSubmodules === false ? "" : "none" }}></KeyboardDoubleArrowDownIcon>
        <KeyboardDoubleArrowUpIcon style={{ display: showSubmodules === true ? "" : "none" }}></KeyboardDoubleArrowUpIcon>

        <h4 className="module-name">{name}</h4>
      </div>
      {showSubmodules && (
        <ul className="submodules-list">
          {submodules?.map((submodule) => (
            <li key={submodule.id}>
              <Submodule
                submodule={submodule}
                name={name}
                module={module}
                setData={setData}
                module2={module2}
                setData2={setData2}
                flag_data={flag_data}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const Submodule = ({ submodule, module, setData, module2, setData2, flag_data, name }) => {
  const [showCheckboxes, setShowCheckboxes] = useState(false);
  const [showSpecialActions, setShowSpecialActions] = useState(false);
  const [updatedSubmodule, setUpdatedSubmodule] = useState(submodule);

  const toggleCheckboxes = () => {
    setShowCheckboxes(!showCheckboxes);
    setShowSpecialActions(true);
  };

  const validateFlag = (updatedLevels, selectedLevel) => {
    return updatedLevels.map((lvl) => ({
      ...lvl,
      flag: lvl.level === selectedLevel.level,
    }));
  };

  const handleCheckboxChange = (level) => {
    const updatedLevels = validateFlag(
      updatedSubmodule.available_levels.map((lvl) => ({
        ...lvl,
        flag: lvl.level === level.level ? !lvl.flag : lvl.flag,
      })),
      level
    );

    setUpdatedSubmodule({
      ...updatedSubmodule,
      available_levels: updatedLevels,
    });
  };
  function fusionarSubmodulo(objetoOriginal, submoduloModificado) {
    const nuevoModulos = objetoOriginal.modules.map((modulo) => {
      const nuevoSubmodulos = modulo.submodules.map((submodulo) => {
        if (submodulo.id === submoduloModificado.id) {
          return {
            ...submodulo,
            ...submoduloModificado,
          };
        }
        return submodulo;
      });
      return {
        ...modulo,
        submodules: nuevoSubmodulos,
      };
    });

    return {
      ...objetoOriginal,
      modules: nuevoModulos,
    };
  }

  function eliminarObjeto(objetoPrincipal, submoduloAEliminar) {
    const nuevoModulos = objetoPrincipal.modules.map((modulo) => {
      if (modulo.submodules.includes(submoduloAEliminar)) {
        const nuevoSubmodulos = modulo.submodules.filter(
          (submodulo) => submodulo !== submoduloAEliminar
        );

        return {
          ...modulo,
          submodules: nuevoSubmodulos,
        };
      }

      return modulo;
    });

    return {
      ...objetoPrincipal,
      modules: nuevoModulos,
    };
  }

  function keep_data(objetoPrincipal, submoduloAMantener) {
    const nuevoModulos = objetoPrincipal.modules.map((modulo) => {
      if (modulo.submodules.includes(submoduloAMantener)) {
        return {
          ...modulo,
          submodules: [submoduloAMantener],
        };
      } else {
        return {
          ...modulo,
          submodules: [],
        };
      }
    });

    return {
      ...objetoPrincipal,
      modules: nuevoModulos,
    };
  }

  const handle_focus = () => {
    var dt = fusionarSubmodulo(module, updatedSubmodule);
    setData(dt);
    console.log(dt);
  };

  const handle_delete = () => {

    var dt = keep_data(module, submodule);
    // setData2(dt);
    console.log(name);
    console.log(dt);

    var np = mantenerSoloModulo(dt, name);
    console.log(np);

    var dtd = eliminarObjeto(module, submodule);
    setData(dtd);
    console.log(dtd);
    console.log(module2);
    var ee = agregarSubmodulos(module2.modules, np.modules);
    console.log(ee);
    setData2({ modules: ee })
    // console.log(specialAction);
  };

  function agregarSubmodulos(objetoA, objetoB) {
    const objetoAResultado = JSON.parse(JSON.stringify(objetoA));

    objetoB.forEach((moduloB) => {
      const moduloExistente = objetoAResultado.find((moduloA) => moduloA.name === moduloB.name);

      if (moduloExistente) {
        moduloB.submodules.forEach((submoduloB) => {
          const submoduloExistente = moduloExistente.submodules.find(
            (submoduloA) => submoduloA.name === submoduloB.name
          );

          if (submoduloExistente) {
            submoduloExistente.available_levels.forEach((level, index) => {
              if (level.flag) {
                level.flag = submoduloB.available_levels[index].flag || level.flag;
              }
            });

            submoduloB.special_actions.forEach((actionB) => {
              const actionExistente = submoduloExistente.special_actions.find(
                (actionA) => actionA.id === actionB.id
              );
              if (actionExistente) {
              } else {
                submoduloExistente.special_actions.push(actionB);
              }
            });
          } else {
            moduloExistente.submodules.push(submoduloB);
          }
        });
      } else {
        objetoAResultado.push(moduloB);
      }
    });

    return objetoAResultado;
  }







  function mantenerSoloModulo(objetoPrincipal, moduloAMantener) {
    const nuevoModulos = objetoPrincipal.modules.filter((modulo) => {
      return modulo.name === moduloAMantener;
    });

    return {
      ...objetoPrincipal,
      modules: nuevoModulos,
    };
  }


  return (
    <div className="submodule-container">
      <div
        className="special-action-header"
        onClick={toggleCheckboxes}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <KeyboardDoubleArrowDownIcon style={{ display: showCheckboxes === false ? submodule.special_actions.length === 0 ? "none" : "" : "none" }}></KeyboardDoubleArrowDownIcon>
        <KeyboardDoubleArrowUpIcon style={{ display: showCheckboxes === true ? submodule.special_actions.length === 0 ? "none" : "" : "none" }}></KeyboardDoubleArrowUpIcon>
        <p className="action-name">{submodule.name}</p>
        <div style={{ display: "flex", alignItems: "center" }}>
          <p className="access-level-special">{submodule.description}</p>
          <img
            src={flag_data === true ? ADD : DELETE}
            alt=""
            className="icon-delete"
            title={flag_data === true ? "Agregar" : "Eliminar"}
            style={{ cursor: "pointer", marginLeft: "10px" }}
            onClick={() => handle_delete()}
          />
        </div>
      </div>
      {showCheckboxes && (
        <div className="checkboxes-container" style={{ display: flag_data === true ? "none" : "" }}>
          {updatedSubmodule.available_levels.map((level) => (
            <label key={level.level} className="checkbox-label">
              <div className="checkbox-input">
                <input
                  type="checkbox"
                  checked={level.flag}
                  onChange={() => handleCheckboxChange(level)}
                  onBlur={handle_focus}
                />
              </div>
              <div className="checkbox-description">{level.description}</div>
            </label>
          ))}
        </div>
      )}
      {showCheckboxes && showSpecialActions && (
        <div className="special-actions-container">
          {submodule.special_actions?.map((specialAction) => (
            <SpecialAction
              key={specialAction.id}
              specialAction={specialAction}
              module={module}
              setData={setData}
              flag_data={flag_data}
              module2={module2}
              setData2={setData2}
              name={name}
              submodule={submodule}
              handle_delete_submodule={handle_delete}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const SpecialAction = ({ specialAction, module, setData, flag_data, name, module2, setData2, submodule, handle_delete_submodule }) => {
  const [showCheckboxes, setShowCheckboxes] = useState(false);
  const [updatedSubmodule, setUpdatedSubmodule] = useState(specialAction);

  const toggleCheckboxes = () => {
    setShowCheckboxes(!showCheckboxes);
  };

  const validateFlag = (updatedLevels, selectedLevel) => {
    return updatedLevels.map((lvl) => ({
      ...lvl,
      flag: lvl.level === selectedLevel.level,
    }));
  };

  const handleCheckboxChange = useCallback(
    (level) => {
      const updatedLevels = validateFlag(
        updatedSubmodule.available_levels.map((lvl) => ({
          ...lvl,
          flag: lvl.level === level.level ? !lvl.flag : lvl.flag,
        })),
        level
      );

      setUpdatedSubmodule({
        ...updatedSubmodule,
        available_levels: updatedLevels,
      });

      const updatedModule = fusionarSubmodulo(module, {
        ...updatedSubmodule,
        available_levels: updatedLevels,
      });

      setData(updatedModule);
    },
    [setData, updatedSubmodule, module]
  );

  console.log(updatedSubmodule);
  function fusionarSubmodulo(objetoOriginal, accionesEspecialesModificadas) {
    console.log(objetoOriginal);
    const nuevoModulos = objetoOriginal.modules.map((modulo) => {
      const nuevoSubmodulos = modulo.submodules.map((submodulo) => {
        const nuevoSpecialActions = submodulo.special_actions.map((action) => {
          if (action.id === accionesEspecialesModificadas.id) {
            return {
              ...action,
              ...accionesEspecialesModificadas,
            };
          }
          return action;
        });

        return {
          ...submodulo,
          special_actions: nuevoSpecialActions,
        };
      });

      return {
        ...modulo,
        submodules: nuevoSubmodulos,
      };
    });

    return {
      ...objetoOriginal,
      modules: nuevoModulos,
    };
  }

  const handle_focus = () => {
    var dt = fusionarSubmodulo(module, updatedSubmodule);
    setData(dt);
    console.log(dt);
  };
  const handle_delete = () => {
    var dt = keep_data(module, specialAction);
    // setData2(dt);
    console.log(name);
    console.log(dt);

    var np = mantenerSoloModulo(dt, name);
    console.log(np);

    var dtd = eliminarObjeto(module, specialAction);
    setData(dtd);
    console.log(dtd);
    console.log(module2);
    var ee = agregarSubmodulos(module2.modules, np.modules);
    console.log(ee);
    setData2({ modules: ee })
  };

  function eliminarObjeto(objetoPrincipal, objetoAEliminar) {
    const nuevoModulos = objetoPrincipal.modules.map((modulo) => {
      const nuevoSubmodulos = modulo.submodules.map((submodulo) => {
        const nuevoSpecialActions = submodulo.special_actions.filter(
          (action) => action.id !== objetoAEliminar.id
        );

        return {
          ...submodulo,
          special_actions: nuevoSpecialActions,
        };
      });

      return {
        ...modulo,
        submodules: nuevoSubmodulos,
      };
    });

    return {
      ...objetoPrincipal,
      modules: nuevoModulos,
    };
  }

  function keep_data(objetoPrincipal, accionEspecialAMantener) {
    const nuevoModulos = objetoPrincipal.modules.map((modulo) => {
      const nuevoSubmodulos = modulo.submodules.map((submodulo) => {
        const nuevasAccionesEspeciales = submodulo.special_actions.filter(
          (accionEspecial) => accionEspecial === accionEspecialAMantener
        );

        if (nuevasAccionesEspeciales.length > 0) {
          return {
            ...submodulo,
            special_actions: nuevasAccionesEspeciales,
          };
        } else {
          return {
            ...submodulo,
            special_actions: [],
          };
        }
      });

      return {
        ...modulo,
        submodules: nuevoSubmodulos,
      };
    });

    return {
      ...objetoPrincipal,
      modules: nuevoModulos,
    };
  }


  function mantenerSoloModulo(objetoPrincipal, moduloAMantener) {
    const nuevoModulos = objetoPrincipal.modules.filter((modulo) => {
      return modulo.name === moduloAMantener;
    });

    return {
      ...objetoPrincipal,
      modules: nuevoModulos,
    };
  }

  function agregarSubmodulos(objetoA, objetoB) {
    const objetoAResultado = JSON.parse(JSON.stringify(objetoA));

    objetoB.forEach((moduloB) => {
      const moduloExistente = objetoAResultado.find((moduloA) => moduloA.name === moduloB.name);

      if (moduloExistente) {
        moduloB.submodules.forEach((submoduloB) => {
          const submoduloExistente = moduloExistente.submodules.find(
            (submoduloA) => submoduloA.name === submoduloB.name
          );

          if (submoduloExistente) {
            submoduloExistente.available_levels.forEach((level, index) => {
              if (level.flag) {
                level.flag = submoduloB.available_levels[index].flag || level.flag;
              }
            });

            submoduloB.special_actions.forEach((actionB) => {
              const actionExistente = submoduloExistente.special_actions.find(
                (actionA) => actionA.id === actionB.id
              );
              if (actionExistente) {
              } else {
                submoduloExistente.special_actions.push(actionB);
              }
            });
          } else {
            moduloExistente.submodules.push(submoduloB);
          }
        });
      } else {
        objetoAResultado.push(moduloB);
      }
    });

    return objetoAResultado;
  }
  console.log(submodule)

  return (
    <div className="special-action-container">
      <div
        className="special-action-header"
        onClick={toggleCheckboxes}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <p className="action-name">{specialAction.name}</p>
        <div style={{ display: "flex", alignItems: "center" }}>
          <p className="access-level-special">{specialAction.description}</p>
          <img
            src={flag_data === true ? ADD : DELETE}
            alt=""
            className="icon-delete"
            title={flag_data === true ? "Agregar" : "Eliminar"}
            style={{ cursor: "pointer", marginLeft: "10px" }}
            onClick={() => submodule?.special_actions?.length === 1 ? flag_data === true ? handle_delete_submodule() : handle_delete() : handle_delete()}
          />
        </div>
      </div>
      {showCheckboxes && (
        <div className="action-levels" style={{ display: flag_data === true ? "none" : "" }}>
          {specialAction.available_levels.map((level) => (
            <label key={level.level} className="checkbox-label">
              <div className="checkbox-input">
                <input
                  type="checkbox"
                  checked={level.flag}
                  onChange={() => handleCheckboxChange(level)}
                  onBlur={handle_focus}
                />
              </div>
              <div className="checkbox-description">{level.description}</div>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

const SystemRoles = ({ systemRoles, setData, systemRoles2, setData2, handle_save_roles }) => (
  <div className="container-rol">
    <div className="roles-user">
      <div className="module-container-roles" >
        <div className="" >
          <h4 className="module-name-roles">ROLES HABILITADOS </h4>
          {/* <img className="img-save-role" src={SAVE} alt="" title="ACTUALIZAR ROLES"
            onClick={async () => {
              const result = await Confirm(
                "¿Esta usted seguro de actualizar sus roles?",
                "Actualizar roles",
                "Si",
                "No"
              );
              if (result) {
                handle_save_roles();
              } else {
              }
            }} /> */}
        </div>
        {systemRoles?.modules?.map((module) => (
          <Module
            key={module?.id}
            name={module?.name}
            submodules={module?.submodules}
            description={module?.access_level_description}
            module={systemRoles}
            module2={systemRoles2}
            setData={setData}
            setData2={setData2}
            flag_data={false}
          />
        ))}
      </div>
    </div>

    <div className="roles-user">
      <div className="module-container-roles" >
        <div className="" >
          <h4 className="module-name-available">ROLES DISPONIBLES</h4>
        </div>

        {systemRoles2?.modules?.map((module) => (
          <Module
            key={module?.id}
            name={module?.name}
            submodules={module?.submodules}
            description={module?.access_level_description}
            module={systemRoles2}
            module2={systemRoles}
            setData={setData2}
            setData2={setData}
            flag_data={true}
          />
        ))}
      </div>
    </div>

  </div>

);


const ROLES = (props) => {

  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const dialog = useDialog();
  const [message, setmessage] = useState("");
  const [modalT, setmodalT] = useState(false);
  const [modalGeneral, setmodalGeneral] = useState(false);

  const handleSubmit = async () => {
    console.log(props)
    setData([]);
    setmodalT(true);
    setmodalGeneral(false);

    try {
      const roles = flag_data(props?.user_roles);
      const availableRoles = flag_data(addAccessLevelToSubmodules(props.modules));

      setData(roles);
      setData2(availableRoles);
    } catch (error) {
      setData([]);
    } finally {
      setmodalT(false);
      setmodalGeneral(false);
    }
  };

  const handleSubmit_create_user = async () => {
    setData([]);
    setmodalT(true);
    setmodalGeneral(false);

    const availableRoles = flag_data(addAccessLevelToSubmodules(props?.modules));
    try {
      setData({
        "modules": [
          {
            "id": 0,
            "name": "SOPORTE",
            "code": "SP",
            "description": "MÓDULO DE SOPORTES",
            "submodules": [
              {
                "id": 62,
                "name": "CENTRO DE AYUDA",
                "code": "HC",
                "description": "SUBMÓDULO PARA SOLICITAR SOPORTE",
                "special_actions": [],
                "access_level": 0,
                "available_levels": [
                  {
                    "level": 0,
                    "description": "LECTURA",
                    "flag": true
                  },
                  {
                    "level": 1,
                    "description": "LECTURA Y EJECUCIÓN",
                    "flag": false
                  },
                  {
                    "level": 2,
                    "description": "LECTURA Y ESCRITURA",
                    "flag": false
                  },
                  {
                    "level": 3,
                    "description": "LECTURA, ESCRITURA Y EJECUCIÓN",
                    "flag": false
                  }
                ]
              },
              {
                "id": 85,
                "name": "CAPACITACIÓN",
                "code": "TR",
                "description": "SUBMÓDULO DE CAPACITACIÓN AL USUARIO",
                "special_actions": [],
                "access_level": 0,
                "available_levels": [
                  {
                    "level": 0,
                    "description": "LECTURA",
                    "flag": true
                  },
                  {
                    "level": 1,
                    "description": "LECTURA Y EJECUCIÓN",
                    "flag": false
                  },
                  {
                    "level": 2,
                    "description": "LECTURA Y ESCRITURA",
                    "flag": false
                  },
                  {
                    "level": 3,
                    "description": "LECTURA, ESCRITURA Y EJECUCIÓN",
                    "flag": false
                  }
                ]
              },
              {
                "id": 88,
                "name": "MANUALES DE USUARIO",
                "code": "UM",
                "description": "SUBMÓDULO DE MANUALES DE USUARIO",
                "special_actions": [],
                "access_level": 0,
                "available_levels": [
                  {
                    "level": 0,
                    "description": "LECTURA",
                    "flag": true
                  },
                  {
                    "level": 1,
                    "description": "LECTURA Y EJECUCIÓN",
                    "flag": false
                  },
                  {
                    "level": 2,
                    "description": "LECTURA Y ESCRITURA",
                    "flag": false
                  },
                  {
                    "level": 3,
                    "description": "LECTURA, ESCRITURA Y EJECUCIÓN",
                    "flag": false
                  }
                ]
              }
            ],
            "access_level": 0
          }
        ]
      });
      setData2(availableRoles);

    } catch (error) {
      setData([]);
    } finally {
      setmodalT(false);
      setmodalGeneral(false);
    }
  };


  function getAccessLevels(accessLevel) {
    return [0, 1, 2, 3].map(level => ({
      level,
      description: [
        "LECTURA",
        "LECTURA Y EJECUCIÓN",
        "LECTURA Y ESCRITURA",
        "LECTURA, ESCRITURA Y EJECUCIÓN"
      ][level],
      flag: accessLevel === level
    }));
  }

  function flag_data(data) {
    data.forEach(module => {
      module.submodules.forEach(submodule => {
        submodule.available_levels = getAccessLevels(submodule.access_level);

        submodule.special_actions?.forEach(specialAction => {
          specialAction.available_levels = getAccessLevels(specialAction.access_level);
        });
      });
    });

    return { modules: data };
  }


  function addAccessLevelToSubmodules(originalObject) {
    const modifiedObject = JSON.parse(JSON.stringify(originalObject));

    function setAccessLevel(entity) {
      entity.access_level = 0;

      if (entity.submodules) {
        entity.submodules.forEach(setAccessLevel);
      }

      if (entity.special_actions) {
        entity.special_actions.forEach(setAccessLevel);
      }
    }

    modifiedObject.forEach(setAccessLevel);

    return modifiedObject;
  }

  function updateAccessLevels(data) {
    console.log(data)
    if (!data || !Array.isArray(data.modules)) {
      return [];
    }
    const updatedData = JSON.parse(JSON.stringify(data));

    for (const module of updatedData.modules) {
      for (const submodule of module.submodules) {
        const availableLevel = submodule.available_levels.find(level => level.flag === true);
        submodule.access_level = availableLevel ? availableLevel.level : 0;
        submodule.special_actions.forEach(action => {
          const actionAvailableLevel = action.available_levels.find(level => level.flag === true);
          action.access_level = actionAvailableLevel ? actionAvailableLevel.level : 0;
        });
      }
    }
    return updatedData;
  }


  const handle_save_roles = async () => {

    try {
      setmodalT(true);
      setmessage("Actualizando roles...");
      const dt = updateAccessLevels(data);
      const filteredModules = dt.modules.filter(module => module.submodules.length > 0);
      await post_rol_user({ roles: { modules: filteredModules } }, Number(props.id));
    } catch (error) {
      console.error("Error al actualizar roles:", error);
      alert(error.response.data.message);
    } finally {
      setmodalT(false);
      setmodalGeneral(false);
      setmessage("");
      dialog.close();
    }
  };


  useEffect(() => {
    if (props?.operation === "CREATE") {
      handleSubmit_create_user();
    }
  }, [props?.modules])

  useEffect(() => {
    props?.operation === "CREATE" ? handleSubmit_create_user() : handleSubmit();
  }, [props?.operation]);



  useEffect(() => {
    console.log((updateAccessLevels(data)))
    props?.setCustomRoles(updateAccessLevels(data))

  }, [data])

  return (
    <>
      <MODAL_TABLE
        open={true}
        message={message}
        modalGeneral={modalGeneral}
        modalT={modalT}
      ></MODAL_TABLE>
      <SystemRoles
        systemRoles={data}
        setData={setData}
        systemRoles2={data2}
        setData2={setData2}
        handle_save_roles={handle_save_roles}
      />
    </>
  );
};

export default ROLES;
